import { tns } from 'tiny-slider/src/tiny-slider'

// Location slider

// var selection = document.querySelectorAll('.slider-location')
// var total_wrap = selection.length
// var j = 0
// if (selection !== null) {
//   for (var i in selection) {
//     j++
//     if (total_wrap >= j) {
//       var id_section = selection[i].id
//       var disable_toggle = document.getElementById(id_section).getAttribute('disable-toggle') == 'false' ? false : true
//       var disable_toggle_mobile = document.getElementById(id_section).getAttribute('disable-toggle-mobile') == 'true' ? false : true
//       var disable_toggle_controls = document.getElementById(id_section).getAttribute('disable-toggle-controls') == 'true' ? false : true
//       var width = $('body').width()
//       if (disable_toggle_controls && width > 1100 && document.getElementById(id_section + '-list') !== null) {
//         document.getElementById(id_section + '-list').style.paddingRight = '85px'
//       }
//       const slider_2 = tns({
//         container: '#' + id_section,
//         navPosition: 'bottom',
//         controls: false,
//         controlsText: ['', ''],
//         mouseDrag: true,
//         speed: 400,
//         slideBy: 'page',
//         swipeAngle: false,
//         loop: false,
//         disable: true,
//         responsive: {
//           300: {
//             disable: disable_toggle_mobile,
//             items: 2,
//             nav: true,
//             controls: false,
//             navPosition: 'bottom',
//           },
//           500: {
//             disable: disable_toggle_mobile,
//             items: 3,
//             nav: true,
//             controls: false,
//             navPosition: 'bottom',
//           },
//           768: {
//             disable: disable_toggle_mobile,
//             items: 3,
//             nav: true,
//             controls: false,
//             navPosition: 'bottom',
//           },
//           1100: {
//             slideBy: 1,
//             items: 4,
//             nav: false,
//             controls: disable_toggle_controls,
//             disable: disable_toggle,
//           },
//         },
//       })
//     }
//   }
// }


// related-campaign-slider123
var selection_relatedCampaign = document.querySelectorAll('.related-campaign-slider')
var total_wrap_relatedCampaign = selection_relatedCampaign.length

var k = 0
if (selection_relatedCampaign !== null) {
  for (var i in selection_relatedCampaign) {
    k++
    if (total_wrap_relatedCampaign >= k) {
      var id_section = selection_relatedCampaign[i].id
      //var disable_toggle = document.getElementById(id_section).getAttribute('disable-toggle') == 'false' ? false : true
      //  var disable_toggle_controls = document.getElementById(id_section).getAttribute('disable-toggle-controls') == 'true' ? false : true
      const slider_3 = tns({
        container: '#' + id_section,
        navPosition: 'bottom',
        controls: false,
        controlsText: ['', ''],
        mouseDrag: true,
        speed: 400,
        slideBy: 'page',
        swipeAngle: false,
        loop: true,
        disable: true,
        responsive: {
          300: {
            disable: false,
            gutter: 2,

            items: 1,
            nav: true,
            navPosition: 'bottom',
          },
          500: {
            disable: false,
            gutter: 20,
            items: 2,
            nav: true,
            navPosition: 'bottom',
          },
          768: {
            disable: false,
            items: 2,
            gutter: 20,
            nav: true,
            navPosition: 'bottom',
          },
          1100: {
            slideBy: 1,
            items: 3,
            nav: false,
            disable: true,
          },
        },
      })
    }
  }
}
// Campaign big slider.

var selection = document.querySelector('.slider') !== null
if (selection) {
  const slider = tns({
    container: document.querySelector('.slider'),
    preventScrollOnTouch: 'forced',
    navPosition: 'bottom',
    controls: false,
    items: 1,
    gutter: 0,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    speed: 600,

    responsive: {
      350: {
        controls: false,
        nav: true,
        navPosition: 'bottom',
      },
      769: {
        nav: false,
        controls: false,
      },
    },
  })

  document.querySelector('.campaign-slider-next').onclick = () => {
    slider.goTo('next')
  }

  document.querySelector('.campaign-slider-prev').onclick = () => {
    slider.goTo('prev')
  }
}

// Campaign carousel slider

var selection = document.querySelectorAll('.slider-carousel')
var total_wrap = selection.length
var j = 0
for (var i in selection) {
  j++
  if (total_wrap >= j) {
    var id_section = selection[i].id

    var disable_toggle = document.getElementById(id_section).getAttribute('disable-toggle') == 'false' ? false : true
    const slider_2 = tns({
      container: '#' + id_section,
      navPosition: 'bottom',
      controls: false,
      nav: true,
      mouseDrag: true,
      items: 2,
      gutter: 0,
      speed: 0,

      responsive: {
        300: {
          nav: true,
          navPosition: 'bottom',
          items: 1,
        },
        720: {
          nav: true,
          navPosition: 'bottom',
          items: 2,
        },
        769: {
          slideBy: 2,
          disable: disable_toggle,
          nav: true,
          mouseDrag: false,
          controls: true,
          controlsText: ['<', '>'],
        },
      },
    })
  }
}
